import i18next from "i18next"

import { SubscriptionPlan } from "@tfg/types/endpoints/subscriptionPlan"

/* Keeping this enum is important if the subscriptionPlans change in the shared types/ package
   The type checking of this const will break if a key is added or removed from the backend subscriptionPlan definition */
export const SUBSCRIPTION_PLANS_WITH_TRANSLATIONS = {
  [SubscriptionPlan.STARTER]: {
    name: i18next.t("tabs.general.subscriptionPlans.STARTER.name", "STARTER", {
      ns: "communicationStudio",
    }),
    description: i18next.t(
      "tabs.general.subscriptionPlans.STARTER.description",
      "STARTER description",
      { ns: "communicationStudio" }
    ),
  },
  [SubscriptionPlan.ADVANCED]: {
    name: i18next.t(
      "tabs.general.subscriptionPlans.ADVANCED.name",
      "ADVANCED",
      { ns: "communicationStudio" }
    ),
    description: i18next.t(
      "tabs.general.subscriptionPlans.ADVANCED.description",
      "ADVANCED description",
      { ns: "communicationStudio" }
    ),
  },
  [SubscriptionPlan.EXPERT]: {
    name: i18next.t("tabs.general.subscriptionPlans.EXPERT.name", "EXPERT", {
      ns: "communicationStudio",
    }),
    description: i18next.t(
      "tabs.general.subscriptionPlans.EXPERT.description",
      "EXPERT description",
      { ns: "communicationStudio" }
    ),
  },
} satisfies Record<
  Exclude<SubscriptionPlan, "NONE">,
  { name: string; description: string }
>
